module.exports = __webpack_public_path__ + "media/svg-new/icon-close-6dce6b41.svg";